// YNX — VISITOR PREVIEW BANNER
// ───────────────────────────────────────────────────────────────
// Shown at the top of the landing/onboarding/demo when the master admin
// (Carl) has clicked "Aperçu visiteur" in his Business Hub. Lets him return
// to his own workspace in one click via sessionStorage restore.
// ───────────────────────────────────────────────────────────────
import React, { useEffect, useState } from 'react';
import { Eye, ArrowLeft } from 'lucide-react';
import { setLocalWorkspace } from '../lib/biz';

const RESTORE_KEY = 'ynx_preview_restore_ws';
const RESTORE_NAME_KEY = 'ynx_preview_restore_name';

const safeGet = (k) => {
  try { return sessionStorage.getItem(k); }
  catch (e) { console.debug('YNX preview: sessionStorage read failed', e); return null; }
};
const safeRemove = (k) => {
  try { sessionStorage.removeItem(k); }
  catch (e) { console.debug('YNX preview: sessionStorage remove failed', e); }
};

export const PreviewBanner = () => {
  const [restoreId, setRestoreId] = useState(null);
  const [restoreName, setRestoreName] = useState('');

  useEffect(() => {
    const id = safeGet(RESTORE_KEY);
    if (id) {
      setRestoreId(id);
      setRestoreName(safeGet(RESTORE_NAME_KEY) || '');
    }
  }, []);

  if (!restoreId) return null;

  const restore = () => {
    try {
      setLocalWorkspace(restoreId);
      safeRemove(RESTORE_KEY);
      safeRemove(RESTORE_NAME_KEY);
      // Hard reload so App.js fully re-hydrates from localStorage
      window.location.href = '/';
    } catch (e) {
      console.warn('YNX preview restore failed', e);
      window.location.href = '/';
    }
  };

  const dismiss = () => {
    safeRemove(RESTORE_KEY);
    safeRemove(RESTORE_NAME_KEY);
    setRestoreId(null);
  };

  return (
    <div className='ynx-preview-banner' data-testid='preview-banner'>
      <div className='ynx-preview-banner-inner'>
        <span className='ynx-preview-pill'>
          <Eye size={11} /> APERÇU VISITEUR
        </span>
        <span className='ynx-preview-text'>
          Vous explorez le site tel qu'un nouveau prospect le voit.
          {restoreName && (
            <>
              {' · '}
              <b>Votre espace : {restoreName}</b>
            </>
          )}
        </span>
        <button
          className='ynx-preview-restore-btn'
          onClick={restore}
          data-testid='preview-restore-btn'
        >
          <ArrowLeft size={11} /> Retour à mon espace
        </button>
        <button
          className='ynx-preview-dismiss'
          onClick={dismiss}
          title='Quitter le mode aperçu (ne restaure pas)'
          aria-label='Dismiss'
        >
          ×
        </button>
      </div>
    </div>
  );
};
